import AdyenDropIn from './AdyenDropIn'

export default AdyenDropIn
// eslint-disable-next-line import/export
export * from './AdyenDropIn'
